import React from "react";
import "./divider.scss";

export function Divider() {
  return <span className="flow-designer-control-panel_divider"> </span>;
}

export default Divider;
